<template>
    <div data-testid="mkt-date" class="mkt-date">
        <VJoyIcon name="calendar" :color="iconColor" />
        <div v-if="phraseKeyWithDate" style="display: flex; flex-wrap: wrap">
            <div class="joy-mr-1">{{ $t(phraseKeyWithDate) }} :</div>
            <div>{{ formattedDate }}</div>
        </div>
        <div v-else>{{ formattedDate }}</div>
    </div>
</template>

<script setup lang="ts">
    import {capitalize, computed} from 'vue';
    import {useFormat} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';
    import {useVariants} from '../../composables/useVariants';
    import type {TranslationKey} from '#build/i18n';

    type MktDateProps = {
        date: Date;
        phraseKeyWithDate?: TranslationKey;
        isTimeVisible?: boolean;
    };

    const props = defineProps<MktDateProps>();

    const {formatDate} = useFormat();
    const {icon: iconColor} = useVariants();

    const formattedDate = computed(() => {
        return capitalize(formatDate(props.date, {dateStyle: 'medium', ...(props.isTimeVisible ? {timeStyle: 'short'} : {})}));
    });
</script>
<style lang="scss">
    .mkt-date {
        display: flex;
        align-items: baseline;
        gap: var(--joy-core-spacing-1);

        .joy-icon {
            position: relative;
            top: 2px;
        }

        & > div {
            display: flex;
            flex-wrap: wrap;
            & > div {
                white-space: nowrap;
            }
        }
    }
</style>
